import { automation } from './automation';

export const v1 = {
  automation,
};
